export const ClearRobotState = (clearSavingAgreementData?: () => void, clearRobotData?: () => void) => {
  clearSavingAgreementData?.();
  if (clearRobotData) {
    clearRobotData();
  }
};
